import { Knisot } from '../../../../../../../modules/API/Knisot/knisot'
import useDebounce from '../../../../seller/Helpers/useDebounce'
import useDataFetcher from '../../../hooks/useFetchData'

export const EXTERNAL_PALLET_CHECK_DELAY = 1000

export interface IUseExternalPalletCheckParams {
  externalPallet: number
  growerID: number
  ownExternalPallet: number
}

export interface IUseExternalPalletCheckResult {
  isExist: boolean
  isChecking: boolean
}

export const buildExternalPalletQuery = (
  externalPallet: number,
  growerID: number,
  ownExternalPallet: number,
): string => {
  if (!(externalPallet > 0) || !growerID || externalPallet === ownExternalPallet) return ''
  return `ExternalPallet=${externalPallet}&GrowerID=${growerID}`
}

const useExternalPalletCheck = ({
  externalPallet,
  growerID,
  ownExternalPallet,
}: IUseExternalPalletCheckParams): IUseExternalPalletCheckResult => {
  const debounced = useDebounce(externalPallet, EXTERNAL_PALLET_CHECK_DELAY)
  const query = buildExternalPalletQuery(debounced, growerID, ownExternalPallet)
  const { data, isLoading, error } = useDataFetcher(Knisot.checkExternalPallet, query)

  // useDataFetcher не сбрасывает data при пустой query, при ошибке и пока грузится новая query —
  // гейтим устаревший ответ
  const isExist = !!query && !error && debounced === externalPallet && !isLoading && !!data?.isExist

  return { isExist, isChecking: !!query && isLoading }
}

export default useExternalPalletCheck
